import React, { useState } from "react";
import { Item } from "semantic-ui-react";
import "./HQuoteStrip.scss";
import PropTypes from "prop-types";
import Icon from "../Icon";

export const HQuoteStrip = ({ quotes }) => {
  const [activeIx, setActiveIx] = useState(0);

  return (
    <section className="hireart-ds-quote-strip">
      <section className="hireart-ds-quote-strip-content">
        <section className="hireart-ds-quote-strip-window">
          <section
            className="hireart-ds-quote-strip-canvas"
            style={{ marginLeft: `-${activeIx * 100}vw` }}
          >
            <Item.Group>
              {quotes.map(({ image, logo, quote, attribution }, i) => {
                return (
                  <Item
                    className={`hireart-ds-quote-strip-slide  ${
                      activeIx === i && "active"
                    }`}
                    style={{ left: `${i * 100}vw` }}
                  >
                    <Item.Image
                      size="small"
                      src={image}
                      className="hireart-ds-quote-strip-image"
                    />
                    <Item.Content>
                      <Item.Header>
                        <img
                          src={logo}
                          className="hireart-ds-quote-strip-logo"
                        />
                        <p>"{quote}"</p>
                      </Item.Header>
                      <Item.Description className="hireart-ds-quote-strip-attr">
                        {attribution}
                      </Item.Description>
                    </Item.Content>
                  </Item>
                );
              })}
            </Item.Group>
          </section>
        </section>
      </section>

      <section className="hireart-ds-quote-strip-controls">
        <Icon
          type="chevron_left"
          size="md"
          onClick={() => setActiveIx(Math.max(0, activeIx - 1))}
          disabled={activeIx === 0}
        />
        <Icon
          type="chevron_right"
          size="md"
          onClick={() => setActiveIx(Math.min(quotes.length - 1, activeIx + 1))}
          disabled={activeIx === quotes.length - 1}
        />
      </section>
    </section>
  );
};

HQuoteStrip.propTypes = {
  quotes: PropTypes.array,
};

